import { render, staticRenderFns } from "./FeatureDetail.vue?vue&type=template&id=606448f6&scoped=true"
import script from "./FeatureDetail.vue?vue&type=script&lang=js"
export * from "./FeatureDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606448f6",
  null
  
)

export default component.exports